// 加密
import jsEncrypt from "jsencrypt";
import Storage from './storage';

export default function encryptPwd(pw) {
  const encrypt = new jsEncrypt();
  encrypt.setPublicKey(Storage.getPublicKey());
  return encrypt.encrypt(pw);
}